import React from 'react'
import './JuneteenthPage.css'

const EB = 'https://steampunkteaparty2026.eventbrite.com'
const TYPEFORM = 'https://m4k691fqe81.typeform.com/to/BqVc8Y0Y'
const INSTAGRAM = 'https://instagram.com/houseafrocon'
const SITE = 'https://afroscapescurls.com'

/** Root-absolute paths so images work on /juneteenth (relative img/… would 404). */
const TK_IMG = `${(process.env.PUBLIC_URL ?? '').replace(/\/$/, '')}/img/events/juneteenth`
/** Spaces / & in filenames must be URL-encoded */
const IMG = {
    freedom: `${TK_IMG}/JuneteenthFreedomLab.png`,
    vaudeville: `${TK_IMG}/JuneteenthVaudevilleShow.png`,
    vip: `${TK_IMG}/juneteenthsteampunkVIPDinner%26Adventure.png`,
    ball: `${TK_IMG}/Ball.png`,
    /** Repo file is `BallTicketsQR .png` (space before extension); qr.png is optional fallback */
    qr: `${TK_IMG}/BallTicketsQR%20.png`,
    herald: `${TK_IMG}/theherald.png`,
    guardiansFaction: `${TK_IMG}/GuardiansofTime2.png`,
    scholarsFaction: `${TK_IMG}/LEGENDARYSCHOLARS%202.png`,
    royalCourtFaction: `${TK_IMG}/TheRoyalCourt2.png`,
    archaeologistsFaction: `${TK_IMG}/TheArchaeologists2.png`,
}

const JuneteenthPage: React.FC = () => {
    return (
        <>
            <div className="juneteenth-layout">
                <nav className="tk-subnav" aria-label="Juneteenth page sections">
                    <a href="/juneteenth" className="tk-subnav-logo">
                        Timekeepers of Timbuktu
                    </a>
                    <ul className="tk-subnav-links">
                        <li>
                            <a href="/juneteenth#tk-events">Events</a>
                        </li>
                        <li>
                            <a href="/juneteenth#tk-story">The Story</a>
                        </li>
                        <li>
                            <a href="/juneteenth#tk-factions">The Factions</a>
                        </li>
                        <li>
                            <a href="/juneteenth#tk-events">The Tickets</a>
                        </li>
                    </ul>
                    <a href={TYPEFORM} target="_blank" rel="noopener noreferrer" className="tk-subnav-cta">
                        Declare Allegiance
                    </a>
                </nav>

                <div className="juneteenth-page">
                <section className="tk-hero" id="tk-home">
                    <div className="tk-hero-ring" style={{ width: 280, height: 280, animationDelay: '0s' }} />
                    <div className="tk-hero-ring" style={{ width: 560, height: 560, animationDelay: '1s' }} />
                    <div className="tk-hero-ring" style={{ width: 840, height: 840, animationDelay: '2s' }} />
                    <div className="tk-hero-ring" style={{ width: 1120, height: 1120, animationDelay: '3s' }} />
                    <div className="tk-hero-ring" style={{ width: 1500, height: 1500, animationDelay: '4s' }} />
                    <div className="tk-hero-inner">
                        <p className="tk-hero-eyebrow">House of Afros, Capes &amp; Curls</p>
                        <p className="tk-hero-org">Omaha, Nebraska · A Juneteenth Weekend Experience</p>
                        <p className="tk-hero-presents">Proudly Presents</p>
                        <h1 className="tk-hero-main">
                            Timekeepers
                            <br />
                            of Timbuktu
                        </h1>
                        <p className="tk-hero-theme">The Juneteenth Steampunk Ball 2026</p>
                        <p className="tk-hero-dates">June 13 – 14, 2026 · Omaha, Nebraska</p>
                        <div className="tk-hero-rule">
                            <div className="tk-hero-rule-line" />
                            <div className="tk-hero-rule-gem" />
                            <div className="tk-hero-rule-line" />
                        </div>
                        <p className="tk-hero-desc">
                            This year&apos;s theme pays tribute to the legendary city of scholars and inventors — envisioning a
                            world where African innovation shapes the engines of time itself. A full-weekend interactive
                            narrative journey blending story, performance, and history.
                        </p>
                        <div className="tk-hero-btns">
                            <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-btn-gold">
                                Get Tickets
                            </a>
                            <a href="/juneteenth#tk-story" className="tk-btn-outline">
                                Hear the Herald&apos;s Call
                            </a>
                        </div>
                    </div>
                    <div className="tk-scroll-hint">
                        <span>Scroll</span>
                        <div className="tk-scroll-line" />
                    </div>
                </section>

                <section className="tk-weekend">
                    <div className="tk-section-inner">
                        <p className="tk-eyebrow">The Weekend Experience</p>
                        <div className="tk-sec-rule">
                            <div className="tk-sec-rule-line" />
                            <div className="tk-sec-rule-gem" />
                            <div className="tk-sec-rule-line" />
                        </div>
                        <h2 className="tk-sec-title tk-weekend-title">
                            Two Days. Four Events.
                            <br />
                            One Living Story.
                        </h2>
                        <p className="tk-weekend-body">
                            This June, The House of Afros, Capes &amp; Curls is back with multiple Juneteenth Steampunk events.
                            Get ready to immerse yourself in a celebration of Black excellence.
                        </p>
                        <p className="tk-weekend-body">
                            This year&apos;s experience expands into a full-weekend interactive narrative journey, blending
                            story, performance, and history in a choose-your-own-adventure format. Participants become Keepers
                            of Time, unlocking hidden moments and storylines throughout each event.
                        </p>
                        <div className="tk-weekend-cta-row">
                            <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-btn-gold">
                                All Tickets — Eventbrite
                            </a>
                            <a href="/juneteenth#tk-factions" className="tk-btn-outline">
                                Choose Your Faction
                            </a>
                        </div>
                    </div>
                </section>

                <section className="tk-events" id="tk-events">
                    <div className="tk-section-inner">
                        <p className="tk-eyebrow">Event Schedule</p>
                        <div className="tk-sec-rule">
                            <div className="tk-sec-rule-line" />
                            <div className="tk-sec-rule-gem" />
                            <div className="tk-sec-rule-line" />
                        </div>
                        <h2 className="tk-sec-title tk-events-heading">
                            The Four Gatherings
                            <br />
                            of the Empire.
                        </h2>
                    </div>

                    <div className="tk-events-grid">
                        <div className="tk-ecard tk-c-family">
                            <img className="tk-ecard-img" src={IMG.freedom} alt="Freedom Lab &amp; Family Day" />
                            <div className="tk-ecard-body">
                                <span className="tk-ecard-num">Event 01</span>
                                <p className="tk-ecard-day">Saturday · June 13, 2026</p>
                                <h3 className="tk-ecard-name">
                                    Juneteenth STEAM-Punk
                                    <br />
                                    Freedom Lab &amp; Family Day
                                </h3>
                                <div className="tk-ecard-meta">
                                    12pm – 3pm · Church Art House
                                    <br />
                                    3101 S 20th St, Omaha, NE 68108
                                </div>
                                <p className="tk-ecard-desc">
                                    An interactive, hands-on space where community and families explore the meaning of freedom
                                    through creativity, history, science, and imagination.
                                </p>
                                <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-ecard-btn">
                                    Get Tickets
                                </a>
                            </div>
                        </div>

                        <div className="tk-ecard tk-c-vaudeville">
                            <img className="tk-ecard-img" src={IMG.vaudeville} alt="Vaudeville Show" />
                            <div className="tk-ecard-body">
                                <span className="tk-ecard-num">Event 02</span>
                                <p className="tk-ecard-day">Saturday · June 13, 2026</p>
                                <h3 className="tk-ecard-name">
                                    21+ SteamPunk Vaudeville
                                    <br />
                                    Show + Vendor Market
                                </h3>
                                <div className="tk-ecard-meta">
                                    7pm – 10pm · Church Art House
                                    <br />
                                    3101 S 20th St, Omaha, NE 68108
                                </div>
                                <p className="tk-ecard-desc">
                                    Featuring nationally recognized, regional, and local artists. Handcrafted art, jewelry,
                                    vintage costuming, artifacts, and more.
                                </p>
                                <ul className="tk-ecard-includes">
                                    <li>Live national &amp; local performers</li>
                                    <li>Vendor market — art, jewelry, vintage costumes &amp; artifacts</li>
                                    <li>21+ · Themed attire encouraged</li>
                                </ul>
                                <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-ecard-btn">
                                    Get Tickets
                                </a>
                            </div>
                        </div>

                        <div className="tk-ecard tk-c-dinner">
                            <img className="tk-ecard-img" src={IMG.vip} alt="VIP Dinner &amp; Adventure" />
                            <div className="tk-ecard-body">
                                <span className="tk-ecard-num">Event 03</span>
                                <p className="tk-ecard-day">Sunday · June 14, 2026</p>
                                <h3 className="tk-ecard-name">
                                    SteamPunk VIP Dinner
                                    <br />
                                    &amp; Adventure
                                </h3>
                                <div className="tk-ecard-meta">
                                    6pm – 8pm · Bohemian Gardens
                                    <br />
                                    1424 South 13th St, Omaha, NE 68108
                                </div>
                                <p className="tk-ecard-desc">
                                    An intimate VIP experience before the Grand Ball — food, education, movement, and lively
                                    conversation.
                                </p>
                                <ul className="tk-ecard-includes">
                                    <li>3-course dinner by Chef Djamil Bah-Traore, House of Bah</li>
                                    <li>African + African American fusion food education</li>
                                    <li>Pre-Ball dance activity</li>
                                    <li>Ball follows dinner</li>
                                </ul>
                                <p className="tk-ecard-cost">$125</p>
                                <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-ecard-btn">
                                    VIP Tickets
                                </a>
                            </div>
                        </div>

                        <div className="tk-ecard tk-c-ball">
                            <img className="tk-ecard-img" src={IMG.ball} alt="The Grand Steampunk Ball" />
                            <div className="tk-ecard-body">
                                <span className="tk-ecard-num">Event 04</span>
                                <p className="tk-ecard-day">Sunday · June 14, 2026</p>
                                <h3 className="tk-ecard-name">
                                    The Grand
                                    <br />
                                    Steampunk Ball
                                </h3>
                                <div className="tk-ecard-meta">
                                    8pm – 11pm · Bohemian Gardens
                                    <br />
                                    1424 South 13th St, Omaha, NE 68108
                                </div>
                                <p className="tk-ecard-desc">
                                    The culminating event of the weekend — live music, interactive story, and the full Timekeepers
                                    of Timbuktu experience.
                                </p>
                                <ul className="tk-ecard-includes">
                                    <li>Live music &amp; dancing</li>
                                    <li>Interactive story + character-led interactions</li>
                                    <li>Specialty desserts</li>
                                    <li>Portrait studio + curated photography &amp; costume parade</li>
                                    <li>Themed attire encouraged</li>
                                </ul>
                                <p className="tk-ecard-cost">$25</p>
                                <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-ecard-btn">
                                    Ball Tickets
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="tk-qr-strip" id="tk-qr">
                    <div className="tk-qr-inner">
                        <img className="tk-qr-img" src={IMG.qr} alt="Scan for Juneteenth Steampunk Ball tickets" />
                        <div className="tk-qr-text">
                            <h3>
                                Scan for Juneteenth
                                <br />
                                Steampunk Ball Tickets
                            </h3>
                            <p>
                                Point your phone camera at the QR code to purchase tickets directly. Ball tickets are $25 · VIP
                                Dinner &amp; Ball $125. Themed attire is encouraged — come dressed in the story.
                            </p>
                            <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-btn-gold tk-qr-link">
                                steampunkteaparty2026.eventbrite.com
                            </a>
                        </div>
                    </div>
                </section>

                <section className="tk-story" id="tk-story">
                    <div className="tk-section-inner">
                        <p className="tk-eyebrow">The Herald Speaks</p>
                        <div className="tk-sec-rule">
                            <div className="tk-sec-rule-line" />
                            <div className="tk-sec-rule-gem" />
                            <div className="tk-sec-rule-line" />
                        </div>
                        <h2 className="tk-sec-title tk-story-heading">
                            The Story of the
                            <br />
                            Timekeepers.
                        </h2>
                        <div className="tk-story-grid">
                            <div className="tk-story-text">
                                <p className="tk-story-lead">Hear ye, hear ye! A descendant of the empire has been found!</p>
                                <p>
                                    The keepers of knowledge have long waited for your arrival, and it comes not a moment too
                                    soon. We are living in perilous times, and the very existence of our realm is in jeopardy.
                                </p>
                                <p>
                                    I am the Herald of Timbuktu. I have served this empire for longer than most care to count —
                                    present at every proclamation that changed the course of the timeline, every moment that
                                    mattered. <em>I am present now because this moment matters most.</em>
                                </p>
                                <p>
                                    The Juneteenth Steampunk Ball 2026 is not just an event. It is a story — and you are in it.
                                    Timbuktu, reimagined. An empire that never fell. A portal through time, built in secret by
                                    Mansa Musa and the greatest scholars of the medieval world to protect African history — and
                                    the history of its descendants — from erasure.
                                </p>
                                <p>
                                    And now something has been stolen. Something whose absence threatens everything our people
                                    have built, preserved, and refused to let the world forget. The timeline is fracturing. The
                                    four great orders have been called to answer.
                                </p>
                                <p className="tk-story-charge">
                                    This is not a performance you will watch from a seat. Your choices matter. Your presence
                                    matters. The mystery cannot be solved without you.
                                </p>
                                <p>
                                    Four paths are open to you. Each carries its own charge. Each holds a piece of the truth
                                    that no other faction possesses.
                                </p>
                                <p className="tk-story-closing">
                                    Once you choose, your faction will reach out with six weeks of dispatches — each one building
                                    the story, deepening your role, and preparing you for what you will find in the room on the
                                    night.
                                </p>
                                <div className="tk-story-cta">
                                    <p className="tk-story-cta-label">The Timeline Is Fracturing</p>
                                    <p className="tk-story-cta-big">
                                        The Empire Is Watching.
                                        <br />
                                        Choose.
                                    </p>
                                    <a href={TYPEFORM} target="_blank" rel="noopener noreferrer" className="tk-btn-gold">
                                        Declare Your Allegiance
                                    </a>
                                </div>
                            </div>
                            <div className="tk-herald-panel">
                                <img
                                    className="tk-herald-img"
                                    src={IMG.herald}
                                    alt="The Herald of Timbuktu — illustrative artwork for the narrative"
                                />
                                <div className="tk-herald-caption">
                                    <p className="tk-herald-name">The Herald of Timbuktu</p>
                                    <p className="tk-herald-title">Voice of the Eternal Empire</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="tk-factions" id="tk-factions">
                    <div className="tk-section-inner">
                        <p className="tk-eyebrow">The Four Great Orders</p>
                        <div className="tk-sec-rule">
                            <div className="tk-sec-rule-line" />
                            <div className="tk-sec-rule-gem" />
                            <div className="tk-sec-rule-line" />
                        </div>
                        <h2 className="tk-sec-title tk-factions-heading">
                            Choose Your Path.
                            <br />
                            Declare Your Allegiance.
                        </h2>
                        <p className="tk-factions-intro">
                            Read carefully. Choose honestly. Each faction holds only part of the story — only through
                            conversation, cooperation, and careful observation will the pieces come together to reveal what was
                            stolen, and who is responsible.
                        </p>
                    </div>

                    <div className="tk-faction tk-fg tk-faction--reverse">
                        <div className="tk-f-visual">
                            <div className="tk-f-visual-bg" />
                            <img
                                className="tk-f-visual-img"
                                src={IMG.guardiansFaction}
                                alt="Guardians of Time"
                            />
                            <div className="tk-f-visual-overlay" />
                        </div>
                        <div className="tk-f-info">
                            <div className="tk-f-badge">
                                <div className="tk-f-badge-dot" />
                                Arc I · Stewards of the Eternal Empire
                            </div>
                            <h3 className="tk-f-name">Guardians of Time</h3>
                            <p className="tk-f-sub">Warriors of the Eternal Watch</p>
                            <div className="tk-f-rule" />
                            <p className="tk-f-tagline">
                                &ldquo;Guardians of a timeless Mali Empire, these warriors are bound to one sacred mission:
                                protect the past, recover what was stolen, and ensure history is never rewritten.&rdquo;
                            </p>
                            <div className="tk-f-chars">
                                <p className="tk-f-char">
                                    The Sand Warden — keeps an hourglass said to hold the First Desert Storm
                                </p>
                                <p className="tk-f-char">The Rift Runner — slips between seconds, emerging where needed</p>
                                <p className="tk-f-char">
                                    The Bronze Sentinel — armored in ancestral metals, impossible to sway
                                </p>
                            </div>
                            <p className="tk-f-think">Think: Warriors · Royal Guard · Woman King · Dora Milaje</p>
                            <a href={TYPEFORM} target="_blank" rel="noopener noreferrer" className="tk-f-link">
                                Join the Guardians
                            </a>
                        </div>
                    </div>

                    <div className="tk-faction tk-fs">
                        <div className="tk-f-visual">
                            <div className="tk-f-visual-bg" />
                            <img
                                className="tk-f-visual-img"
                                src={IMG.scholarsFaction}
                                alt="Legendary Scholars"
                            />
                            <div className="tk-f-visual-overlay" />
                        </div>
                        <div className="tk-f-info">
                            <div className="tk-f-badge">
                                <div className="tk-f-badge-dot" />
                                Arc II · Visionaries of the Infinite Library
                            </div>
                            <h3 className="tk-f-name">Legendary Scholars</h3>
                            <p className="tk-f-sub">Keepers of the Living Archive</p>
                            <div className="tk-f-rule" />
                            <p className="tk-f-tagline">
                                &ldquo;Timbuktu&apos;s scholars are more than librarians — they are visionaries who blend ancient
                                wisdom, mathematics, and the science of the stars to illuminate the path forward for all of
                                humanity.&rdquo;
                            </p>
                            <div className="tk-f-chars">
                                <p className="tk-f-char">The Archivist — Cartographer of Lost Time</p>
                                <p className="tk-f-char">The Librarian — Keeper of the Living Word</p>
                                <p className="tk-f-char">The Ink Diviner — interprets letters that rearrange themselves</p>
                                <p className="tk-f-char">
                                    The Archivist of Echoes — stores ancestor voices in crystalline memory stones
                                </p>
                                <p className="tk-f-char">The Stargazer Engineer — maps the heavens to craft new futures</p>
                            </div>
                            <p className="tk-f-think">Think: Ancient Librarian · Scholar Mystic</p>
                            <a href={TYPEFORM} target="_blank" rel="noopener noreferrer" className="tk-f-link">
                                Join the Scholars
                            </a>
                        </div>
                    </div>

                    <div className="tk-faction tk-fc tk-faction--reverse">
                        <div className="tk-f-visual">
                            <div className="tk-f-visual-bg" />
                            <img
                                className="tk-f-visual-img"
                                src={IMG.royalCourtFaction}
                                alt="The Royal Court"
                            />
                            <div className="tk-f-visual-overlay" />
                        </div>
                        <div className="tk-f-info">
                            <div className="tk-f-badge">
                                <div className="tk-f-badge-dot" />
                                Arc III · Masters of Influence and Hidden Eyes
                            </div>
                            <h3 className="tk-f-name">The Royal Court</h3>
                            <p className="tk-f-sub">Elegance Woven with Espionage</p>
                            <div className="tk-f-rule" />
                            <p className="tk-f-tagline">
                                &ldquo;The Royal Court rules with style and secrecy. Behind the glamour of Timbuktu&apos;s most
                                powerful nobles lies a vast spy network with one mission: track down stolen African artifacts
                                and bring them home.&rdquo;
                            </p>
                            <div className="tk-f-chars">
                                <p className="tk-f-char">
                                    The Whispering Duke &amp; Duchess — messages stitched into gowns like spells
                                </p>
                                <p className="tk-f-char">The Prince of Mirrors — master of disguise and reflection magic</p>
                                <p className="tk-f-char">
                                    The Court Spymaster — unseen but omnipresent, cloaked in layered indigo
                                </p>
                            </div>
                            <p className="tk-f-think">Think: Bridgerton meets Ancient Africa</p>
                            <a href={TYPEFORM} target="_blank" rel="noopener noreferrer" className="tk-f-link">
                                Join the Court
                            </a>
                        </div>
                    </div>

                    <div className="tk-faction tk-fa">
                        <div className="tk-f-visual">
                            <div className="tk-f-visual-bg" />
                            <img
                                className="tk-f-visual-img"
                                src={IMG.archaeologistsFaction}
                                alt="The Archaeologists"
                            />
                            <div className="tk-f-visual-overlay" />
                        </div>
                        <div className="tk-f-info">
                            <div className="tk-f-badge">
                                <div className="tk-f-badge-dot" />
                                Arc IV · Relentless Seekers of the Lost and Stolen
                            </div>
                            <h3 className="tk-f-name">The Archaeologists</h3>
                            <p className="tk-f-sub">Into the Ruins. Back With What Belongs.</p>
                            <div className="tk-f-rule" />
                            <p className="tk-f-tagline">
                                &ldquo;These adventurers cross deserts, dive deep seas, and infiltrate museums to recover African
                                artifacts taken from the empire. Whatever their reason — honor, wealth, or redemption — the
                                mission is the same: take back what belongs.&rdquo;
                            </p>
                            <div className="tk-f-chars">
                                <p className="tk-f-char">The Desert Fox — agile climber who rides sand-gliders</p>
                                <p className="tk-f-char">The Stormbreaker Diver — explores flooded ruins with amphibious gear</p>
                                <p className="tk-f-char">
                                    The Rogue Curator — once worked for European museums, now steals back what was taken
                                </p>
                            </div>
                            <p className="tk-f-think">Think: An African Indiana Jones</p>
                            <a href={TYPEFORM} target="_blank" rel="noopener noreferrer" className="tk-f-link">
                                Join the Archaeologists
                            </a>
                        </div>
                    </div>
                </section>

                <section className="tk-choose">
                    <div className="tk-hero-ring tk-choose-ring" style={{ width: 400, height: 400, animationDelay: '0s' }} />
                    <div className="tk-hero-ring tk-choose-ring" style={{ width: 800, height: 800, animationDelay: '2s' }} />
                    <div className="tk-section-inner tk-choose-inner">
                        <p className="tk-eyebrow tk-choose-eyebrow">The Empire Awaits</p>
                        <h2 className="tk-choose-title">Which Will You Choose?</h2>
                        <p className="tk-choose-sub">
                            Each costume suggestion is inspiration only. Come as you are, interpreted through the lens of who you
                            choose to be. There is no wrong way to wear your allegiance.
                        </p>
                        <p className="tk-choose-note">Register before the deadline</p>
                        <p className="tk-choose-urgency">The mystery reveals itself only to those who show up.</p>
                        <div className="tk-choose-btns">
                            <a
                                href={TYPEFORM}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="tk-btn-gold tk-choose-btn-primary"
                            >
                                Declare My Allegiance
                            </a>
                            <a href={EB} target="_blank" rel="noopener noreferrer" className="tk-btn-outline">
                                Get Event Tickets
                            </a>
                        </div>
                        <p className="tk-herald-closing">
                            The timeline is fracturing. The empire is watching. Choose.
                            <br />
                            — Yours Dutifully, The Herald of Timbuktu · Voice of the Eternal Empire
                        </p>
                    </div>
                </section>
                </div>

                <footer className="tk-footer">
                    <div className="tk-footer-grid">
                        <div>
                            <span className="tk-footer-logo">Timekeepers of Timbuktu</span>
                            <p className="tk-footer-org">
                                The House of Afros, Capes &amp; Curls
                                <br />
                                Omaha, Nebraska
                                <br />
                          
                                <a href="https://afroscapescurls.com" style={{display:'block'}} target="_blank" rel="noopener noreferrer">afroscapescurls.com</a>
                            
                                @houseafrocon
                            </p>
                        </div>
                        <div>
                            <p className="tk-footer-col-label">Weekend Events</p>
                            <ul className="tk-footer-links">
                                <li>
                                    <a href={EB} target="_blank" rel="noopener noreferrer">
                                        Freedom Lab &amp; Family Day — Jun 13, 12–3pm
                                    </a>
                                </li>
                                <li>
                                    <a href={EB} target="_blank" rel="noopener noreferrer">
                                        Vaudeville Show 21+ — Jun 13, 7–10pm
                                    </a>
                                </li>
                                <li>
                                    <a href={EB} target="_blank" rel="noopener noreferrer">
                                        VIP Dinner &amp; Adventure — Jun 14, 6–8pm
                                    </a>
                                </li>
                                <li>
                                    <a href={EB} target="_blank" rel="noopener noreferrer">
                                        The Grand Steampunk Ball — Jun 14, 8–11pm
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <p className="tk-footer-col-label">Connect</p>
                            <ul className="tk-footer-links">
                                <li>
                                    <a href={EB} target="_blank" rel="noopener noreferrer">
                                        Tickets — Eventbrite
                                    </a>
                                </li>
                                <li>
                                    <a href={TYPEFORM} target="_blank" rel="noopener noreferrer">
                                        Choose Your Faction — Typeform
                                    </a>
                                </li>
                                <li>
                                    <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer">
                                        Instagram — @houseafrocon
                                    </a>
                                </li>
                                <li>
                                    <a href={SITE} target="_blank" rel="noopener noreferrer">
                                        afroscapescurls.com
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="tk-footer-bottom">
                        <p>© 2026 The House of Afros, Capes &amp; Curls · Omaha, Nebraska</p>
                        <p>#TimekeepersOfTimbuktu · #JuneteenthSteampunkBall2026</p>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default JuneteenthPage
